var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23763 7.45707C3.01095 7.45707 1.92859 6.4285 1.92859 5.10605C1.92859 3.85707 2.93879 2.75503 4.23763 2.75503M9.57728 10.6897H8.49492C6.18588 10.6897 4.30978 8.77952 4.30978 6.4285V1.28564H13.8346V6.4285C13.7624 8.77952 11.8863 10.6897 9.57728 10.6897ZM11.0926 10.3958V13.1142H6.97961V10.3958H11.0926ZM14.2675 16.7142H3.80468L5.31999 13.1142H12.68L14.2675 16.7142ZM13.7624 2.75503C14.9891 2.75503 16.0714 3.7836 16.0714 5.10605C16.0714 6.35503 15.0612 7.45707 13.7624 7.45707V2.75503Z",
    stroke: "#F16434",
    strokeWidth: 0.964286,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitor);
export default __webpack_public_path__ + "static/media/competitor.4c40f1d422d3e94a1379606e69a4c609.svg";
export { ForwardRef as ReactComponent };